import state from '@/stores/current_user/state.js'
import mutations from '@/stores/current_user/mutations.js'
import actions from '@/stores/current_user/actions.js'

export default {
  state,
  mutations,
  actions
}
